module.exports = __webpack_public_path__ + "img/lagerausbildung.82b47818.jpg";